module.exports = __webpack_public_path__ + "static/img/kawachi_06.3e082bb.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/recruit/2025/top/story/kawachi_06.jpg
// module id = 2dpa
// module chunks = 0